import { Avatar } from '@amzn/cuminuicomponents';
import { KatIcon } from '@amzn/katal-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'src/redux/hooks';

export type GroupBannerProps = {
  groupId: string;
};

const GroupBanner: React.FC<GroupBannerProps> = ({ groupId }) => {
  const { t, i18n: { format, language } } = useTranslation();
  const group = useAppSelector((state) => state.groups.groups[groupId]);
  if (!group) return null;

  const {
    nameStringId, avatarSrc, memberCount, postCount, isMember,
  } = group;

  return (
    <div
      data-testid="group-banner"
      className="my-5 flex items-center justify-between border border-solid border-kat-seattle bg-kat-azure py-5 px-4"
    >
      <div className="flex items-center space-x-2 rtl:space-x-reverse">
        <Avatar src={avatarSrc} variant="square" />
        <h2 className="!mb-1">{t(nameStringId)}</h2>
        {isMember && <div data-testid="member-badge" className="w-fit rounded-full bg-kat-nordic px-2 text-kat-white">{t('member')}</div>}
      </div>
      <div className="flex space-x-4 text-[14px] font-bold rtl:space-x-reverse">
        <div>
          <KatIcon className="text-kat-eastern ltr:mr-1 rtl:ml-1" name="group" size="small" />
          {t('numberOfMembers', {
            memberCount,
            formattedMemberCount: format(memberCount, 'compactNumber', language),
          })}
        </div>
        <div>
          <KatIcon className="text-kat-eastern ltr:mr-1 rtl:ml-1" name="chat-bubbles" size="small" />
          {t('numberOfDiscussions', {
            postCount,
            formattedPostCount: format(postCount, 'compactNumber', language),
          })}
        </div>
      </div>
    </div>
  );
};

export default GroupBanner;
